import {PassportUserTypes} from "root/Common/Constants/PassportUserTypes.mjs";

export const LoginRouteMaps = [
    {
        user_type: PassportUserTypes.USER_TYPE_ADMIN,
        allow_redirect: false,
        homepage: {
            default: '/admin',
            estar: '/admin',
            ehcp: '/home',
            home: '/',
        },
    },
    {
        user_type: PassportUserTypes.USER_TYPE_TEACHER,
        allow_redirect: false,
        homepage: {
            default: '/mychildren',
            estar: '/mychildren'
        },
    },
    {
        user_type: PassportUserTypes.USER_TYPE_SCHOOL_MANAGER,
        allow_redirect: true,
        homepage: {
            default: '/myorganisation',
            estar: '/'
        },
    },
    {
        user_type: PassportUserTypes.USER_TYPE_TRAINING_ADMIN,
        allow_redirect: false,
        homepage: {
            default: '/training/inbox',
            estar: '/'
        },
    },
    {
        user_type: PassportUserTypes.USER_TYPE_TRAINING_FACILITATOR,
        allow_redirect: false,
        homepage: {
            default: '/training/facilitator',
            estar: '/training/facilitator'
        },
    },
    {
        user_type: PassportUserTypes.USER_TYPE_EXTERNAL_PRACTITIONER,
        allow_redirect: false,
        homepage: {
            default: '/training/home',
            estar: '/'
        },
    },
    {
        user_type: PassportUserTypes.USER_TYPE_EHCP_MANAGER,
        allow_redirect: false,
        homepage: {
            default: '/admin',
            estar: '/admin',
            ehcp: '/home',
        },
    },
    {
        user_type: PassportUserTypes.USER_TYPE_EHCP_COORDINATOR,
        allow_redirect: false,
        homepage: {
            default: '/admin',
            estar: '/admin',
            ehcp: '/home',
        },
    },
    {
        user_type: PassportUserTypes.USER_TYPE_EHCP_ADMIN,
        allow_redirect: false,
        homepage: {
            default: '/admin',
            estar: '/admin',
            ehcp: '/home',
        },
    },
    {
        user_type: PassportUserTypes.USER_TYPE_PASSPORT_GUEST,
        allow_redirect: false,
        homepage: {
            default: '/panels',
            estar: '/panels',
            ehcp: '/',
        },
    },

]

